import * as React from 'react';
import { StaticSettings } from '../StaticSettings';
import { DirectLink } from './Sharing/DirectLink';
import { EmailLink } from './Sharing/EmailLink';
import { Facebook } from './Sharing/Facebook';
import { LinkedIn } from './Sharing/LinkedIn';
import { Print } from './Sharing/Print';
import { SharingProps } from './Sharing/SharingProps';
import { Xing } from './Sharing/Xing';

export class Sharing extends React.Component<SharingProps> {
    public render() {
        if (!StaticSettings.ui.detail.showSharing) {
            return null;
        }

        const model = this.props.model;

        return <div className="jc-share-group">
            <div className="jc-share-label">
                <i className="fas fa-share-alt"/>
                <span>Stelle teilen</span>
            </div>
            <div className="jc-share-links">
                <LinkedIn model={model}/>
                <Xing model={model}/>
                <Facebook model={model}/>
                <EmailLink model={model}/>
                <DirectLink model={model}/>
                <Print model={model}/>
            </div>
        </div>;
    }
}
